/* Aged garlic softgels lander — document-scoped runtime for the modular PDP sections.
   Re-architected from the original <nuralis-pdp> custom element so the pillars
   can live in separate Shopify sections. Everything is null-guarded so a
   removed/reordered pillar never breaks the others. Adds to the Ascendify
   cart drawer in place; falls back to the cart page when no drawer exists. */
(() => {
  if (window.__agsLander) return;               // single init across N section includes
  window.__agsLander = true;

  const boot = () => {
    const $  = (s, r = document) => r.querySelector(s);
    const $$ = (s, r = document) => [...r.querySelectorAll(s)];
    const on = (el, type, fn) => el && el.addEventListener(type, fn);

    const form    = $('[data-product-form],.np-product-form');
    const inputs  = $$('[data-pack-input]');                 // hero + final pickers
    const variantField = $('[data-variant-id]');
    if (variantField) variantField.disabled = false;
    const cartUrl = (document.querySelector('[data-cart-url]') || {}).dataset?.cartUrl;

    let selected = null;
    const selectPack = (input, updateUrl = true) => {
      if (!input || input.disabled) return;
      selected = input;
      inputs.forEach(o => { o.checked = o.value === input.value; });
      if (variantField) variantField.value = input.value;
      if (updateUrl) {                                  // only on a real user change, not on load
        const url = new URL(location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      }
      $$('[data-form-message]').forEach(el => { el.textContent = ''; });
    };
    inputs.forEach(input => on(input, 'change', () => selectPack(input)));
    selectPack(inputs.find(i => i.checked && !i.disabled) || inputs.find(i => !i.disabled), false);
    if (!selected) $$('[data-add-button]').forEach(b => { b.disabled = true; b.textContent = 'Unavailable'; });

    // Sticky bar entry price = lowest available pack (stays an entry price).
    const entry = inputs.filter(i => !i.disabled).sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price))[0];
    if (entry) {
      const price = $('[data-entry-price]');
      if (price) price.textContent = entry.dataset.priceText || `$${(Number(entry.dataset.price) / 100).toFixed(2)}`;
      const detail = $('[data-entry-detail]');
      if (detail) detail.textContent = `\u00b7 ${entry.dataset.days}-day supply`;
    }

    // Gallery
    const slides = $$('[data-slide]');
    const thumbs = $$('[data-go-slide]');
    let slideIndex = 0;
    const goSlide = index => {
      if (!slides.length) return;
      slideIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== slideIndex; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === slideIndex)));
      const count = $('[data-slide-count]');
      if (count) count.textContent = String(slideIndex + 1).padStart(2, '0');
    };
    thumbs.forEach(thumb => on(thumb, 'click', () => goSlide(Number(thumb.dataset.goSlide))));
    $$('[data-slide-step]').forEach(b => on(b, 'click', () => goSlide(slideIndex + Number(b.dataset.slideStep))));
    const gallery = $('.np-slides');
    on(gallery, 'keydown', e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); goSlide(slideIndex + (e.key === 'ArrowRight' ? 1 : -1)); }
    });
    if (gallery) {
      let tx = 0, ty = 0;
      on(gallery, 'touchstart', e => { tx = e.changedTouches[0].clientX; ty = e.changedTouches[0].clientY; });
      on(gallery, 'touchend', e => {
        const dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 65 && Math.abs(dx) > Math.abs(dy) * 1.5) goSlide(slideIndex + (dx < 0 ? 1 : -1));
      });
    }

    // Medical film + chapters
    const video = $('[data-medical-video]');
    const motionToggle = $('[data-motion-toggle]');
    if (video) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let pausedByUser = false;
      const times = $$('[data-motion-time]');
      const syncVideo = () => {
        const label = $('[data-motion-label]');
        if (label) label.textContent = video.paused ? 'Play film' : 'Pause film';
        motionToggle?.querySelector('path')?.setAttribute('d', video.paused ? 'm22 12 30 20-30 20Z' : 'M18 12h10v40H18ZM36 12h10v40H36Z');
        motionToggle?.setAttribute('aria-label', video.paused ? 'Play medical animation' : 'Pause medical animation');
        times.forEach((b, i) => b.setAttribute('aria-pressed', String(video.currentTime >= Number(b.dataset.motionTime) && (i === times.length - 1 || video.currentTime < Number(times[i + 1].dataset.motionTime)))));
      };
      on(video, 'play', syncVideo); on(video, 'pause', syncVideo); on(video, 'timeupdate', syncVideo);
      on(motionToggle, 'click', () => { pausedByUser = !video.paused; if (video.paused) video.play().catch(() => {}); else video.pause(); });
      times.forEach(b => on(b, 'click', () => {           // explicit chapter click always seeks + plays
        pausedByUser = false;
        const t = Number(b.dataset.motionTime) || 0;
        const seek = () => { try { video.currentTime = t; } catch (e) {} };
        if (video.readyState >= 1) seek(); else video.addEventListener('loadedmetadata', seek, { once: true });
        video.play().catch(() => {});
      }));
      const io = new IntersectionObserver(entries => {          // out of view -> pause; in view -> autoplay only,
        if (!entries[0].isIntersecting) video.pause();          // never force-pause a video the user chose to play
        else if (!reduced && !pausedByUser) video.play().catch(() => {});
      }, { threshold: 0.2 });
      io.observe(video); syncVideo();
    }

    // Supplement Facts dialog (opened from hero + mission)
    const labelDialog = $('.np-label-dialog');
    $$('[data-open-label]').forEach(b => on(b, 'click', () => labelDialog?.showModal()));
    $$('[data-close-dialog]').forEach(b => on(b, 'click', () => b.closest('dialog')?.close()));
    $$('dialog').forEach(dialog => on(dialog, 'click', e => {
      if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); }
    }));

    // Sticky buy bar. Reparent to <body> under a scope shell: a transformed section
    // ancestor (e.g. the theme's scroll-reveal) otherwise traps position:fixed, so the
    // bar sits at the bottom of the off-screen section instead of the viewport. The
    // shell keeps the .np/.nv2/.nv7 classes the scoped CSS needs. Visibility is
    // re-evaluated on scroll (not only at observer crossings, which flake at the edge).
    const sticky = $('[data-sticky]');
    if (sticky) {
      const shell = document.createElement('div');
      shell.className = 'np nv2 nv3 nv7 nv8';
      document.body.appendChild(shell);
      shell.appendChild(sticky);
      // Fallback CTA: show only when NO buy/CTA button is on screen, a pack is
      // selected, and the shopper has scrolled past the fold.
      const ctas = $$('[data-add-button], .np-button').filter(el => !el.closest('[data-sticky]'));
      const onScreen = new Set();
      const syncSticky = () => {
        const aboveFold = window.scrollY < window.innerHeight * 0.5;
        sticky.hidden = !selected || aboveFold || onScreen.size > 0;
      };
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => { if (e.isIntersecting) onScreen.add(e.target); else onScreen.delete(e.target); });
        syncSticky();
      }, { threshold: 0 });
      ctas.forEach(c => io.observe(c));
      window.addEventListener('scroll', () => requestAnimationFrame(syncSticky), { passive: true });
      window.addEventListener('resize', syncSticky, { passive: true });
      syncSticky();
    }

    // Header cart bag: open the drawer if present; keep the quantity badge in sync.
    const setCartCount = n => $$('[data-np-cart-count]').forEach(el => { el.textContent = n; el.hidden = !(Number(n) > 0); });
    $$('[data-np-cart]').forEach(a => on(a, 'click', e => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) { e.preventDefault(); if (typeof drawer.open === 'function') drawer.open(); else drawer.classList.add('active', 'is-open', 'open'); }
    }));

    /* ---- Ascendify cart-drawer bridge (add in place; fall back to /cart) ---- */
    const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function swapDrawer(dest, htmlText) {
      if (!dest || !htmlText) return;
      const doc = new DOMParser().parseFromString(htmlText, 'text/html');
      const fresh = doc.querySelector('cart-drawer') || doc.getElementById('shopify-section-cart-drawer') || doc.querySelector('.shopify-section') || doc.body;
      if (!fresh) return;
      const inner = fresh.innerHTML;
      if (!inner || !inner.trim()) return;
      if (fresh.tagName && fresh.tagName.toLowerCase() === 'cart-drawer') {
        [...fresh.attributes].forEach(a => { try { dest.setAttribute(a.name, a.value); } catch (e) {} });
      } else {
        dest.classList.remove('is-empty', 'empty', 'cart-empty', 'drawer--empty', 'cart--empty');
      }
      dest.innerHTML = inner;
    }
    function swapBubble(htmlText) {
      const dest = document.getElementById('cart-icon-bubble');
      if (!dest || !htmlText) return;
      const doc = new DOMParser().parseFromString(htmlText, 'text/html');
      const fresh = doc.getElementById('cart-icon-bubble') || doc.querySelector('.shopify-section') || doc.body;
      const inner = fresh ? fresh.innerHTML : '';
      if (inner && inner.trim()) dest.innerHTML = inner;
    }
    async function drawerAdd(variantId) {
      const drawer = document.querySelector('cart-drawer');
      if (!variantId || !drawer) return false;                 // caller falls back
      const add = await fetch(ROOT + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (!add.ok) throw new Error((await add.json().catch(() => ({}))).description || 'This pack could not be added.');
      const res = await fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble');
      const data = await res.json();
      swapDrawer(drawer, data['cart-drawer']);
      swapBubble(data['cart-icon-bubble']);
      try { const cj = await (await fetch(ROOT + 'cart.js')).json(); setCartCount(cj.item_count); } catch (e) {}
      if (typeof drawer.open === 'function') drawer.open(); else drawer.classList.add('active', 'is-open', 'open');
      return true;
    }

    let busy = false;
    on(form, 'submit', async e => {
      e.preventDefault();
      if (!selected || busy) return;
      busy = true;
      const buttons = $$('[data-add-button]');
      buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      $$('[data-form-message]').forEach(el => { el.textContent = 'Adding your pack\u2026'; });
      try {
        const added = await drawerAdd(selected.value);         // Ascendify drawer
        if (!added) {                                           // no drawer -> plain add + cart page
          const r = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(selected.value), quantity: 1 }] }) });
          if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || 'This pack could not be added.');
          location.assign(cartUrl || ROOT + 'cart');
          return;
        }
        $$('[data-form-message]').forEach(el => { el.textContent = ''; });
        buttons.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); });
        busy = false;
      } catch (err) {
        $$('[data-form-message]').forEach(el => { el.textContent = err.message || 'Something went wrong. Please try again.'; });
        buttons.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); });
        busy = false;
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
